<div class="cads-menu-section" [class.cads-menu-section--disabled]="_isDisabled()">
  @if (_showTitle()) {
    <span class="cads-menu-section__title">{{ _titleText() }}</span>
  }
  <div
    class="cads-menu-section__card"
    [attr.aria-disabled]="_isDisabled() ? true : null"
  >
    <ng-content />
  </div>
</div>
